/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon16Light = forwardRef('ArrowFigureACircleRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 7.5a.5.5 0 0 1 .5-.5h5.119l-1.94-1.616a.5.5 0 1 1 .641-.768l2.078 1.732a1.5 1.5 0 0 1 0 2.304L8.32 10.384a.5.5 0 0 1-.64-.768L9.619 8H4.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 7.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM7.5 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
